import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { store } from './app/store/store';
import { AppRouter } from './app/routes/Router';
import RouteTracker from './features/analytics/components/RouteTracker';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from 'styled-components';
import { theme } from './features/shared/styles/theme';
import './index.css';
import './features/shared/styles/components.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ErrorBoundary from '../src/features/shared/components/ErrorBoundary'

const queryClient = new QueryClient();

export default function App() {
  return (
    <ErrorBoundary>
    <Provider store={store}>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider theme={theme}>
            <RouteTracker />
            <AppRouter />
            <ToastContainer position="top-center" autoClose={2000} />
          </ThemeProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </Provider>
    </ErrorBoundary>
  );
}
